import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Table, TableBody, TableCell, TableContainer, TextField,
    TableHead, TableRow, Paper, TablePagination, TableFooter } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import styled from 'styled-components';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import { useForm } from "react-hook-form";
import { useAddSubInCatMutation, useDelSubInArrMutation } from '../../../features/complmaster/complmasterApiSlice';


const BackArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
  cursor: pointer;
`

const SpecInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

const LabelInputWrapper = styled.div`
    /* margin-bottom:25px; */
    min-height: 40px;
    margin-right:20px;
`
const IconWrapper = styled.div`
  display: flex;
  align-items:center;
  justify-content: space-between;
  width:100%;
`
const SubWrapper = styled.div`
display: flex;
align-items:center;  
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
margin-left: 25px;
width:120px;
font-size: 0.9rem;
`
const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const tableFontSize = 18;

const tarray = (array,data,resultarray=[])=>{
  for(const val of array){
    for(const key of val.Subject){
        let tempobject ={};        
        tempobject= {...tempobject,"id":val.id,"Category":val.Category,"Subject":key}
        resultarray.push(tempobject);
    }
}
return resultarray;
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const SubjectMaster = ({complmaster, categProp, categPropId, onClickBackArrow,setSentData, deleteAssetMaster, Button2Div, ExcelDownload}) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [addSubjectData, setAddSubjectData] = useState({});
    const [addSpecIndex, setAddSpecIndex] = useState(1);
    const [downloadData, setDownloadData] = useState({});
    const [rows, setRows] = useState([]);
    const [editCategory, setEditCategory]=useState(null);
    const [editData, setEditData] = useState({
      catIndex:null,
      assetIndex:null,
      specIndex:null,
      keyValueObject:{}
  
    })
    const [specValueTemp, setSpecValueTemp]=useState([]);
    const { register, handleSubmit, watch, formState: { errors, isSubmitSuccessful }, reset,
     setValue} = useForm();
     const { register:register2, handleSubmit:handleSubmit2, formState: { errors: errors2,
       isSubmitSuccessful:isSubmitSuccessful2 }, reset:reset2,setValue:setValue2} = useForm();
    
    const [addSubInCatCompl] = useAddSubInCatMutation();
    const [delSubInArrCompl] = useDelSubInArrMutation();

  
    // Expand rows into individual subject rows for the table
    const expandedRows = useMemo(() => tarray(rows), [rows]);

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - expandedRows.length) : 0;
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
      };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      };
  
    const onClickaddicon = () =>{
      setAddSpecIndex(addSpecIndex+1)
      }
  
    const onClickremoveicon = () =>{
      let temp = {...addSubjectData};
      for(const key in temp){
        console.log(key.charAt(key.length-1))
        console.log(addSpecIndex-1)
          const levelIndex = key.charAt(key.length-1);
          if(Number(levelIndex) >= (addSpecIndex-1)){
            console.log(key)
              delete temp[key];
          }
      }
      if(addSpecIndex > 1){
          setAddSpecIndex(addSpecIndex-1)
          }
      setAddSubjectData(temp)
    }
  
     //Find the index of Category
     const catIndex = Object.values(complmaster).findIndex(p => p.Category === categProp);
     console.log(catIndex)    
    
    const onFormSubmit = async (e) =>{
      e.preventDefault();
      const temp = {...addSubjectData};
      const tempArray = Object.values(temp);
      if(!tempArray.some(item => Object.values(complmaster)[catIndex].Subject.includes(item))){
        const body = {id:categPropId, data:tempArray};
        console.log(body)
        const res = await addSubInCatCompl(body);
        console.log(res)
        setAddSubjectData({})
      }else{
        alert("Subject value already exists in the database")
      }      
    }

    const handleDeleteClick = (e,k,row) =>{
      console.log(row.Subject)
      const res = delSubInArrCompl({"id":row.id, "delSubValue":row.Subject})
    } 

    const handleAddSubject = (event) =>{
        let temp = {...addSubjectData};
        temp = {...temp, [event.target.name]:event.target.value};        
        setAddSubjectData(temp);
    }
    console.log(addSubjectData)

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["Category","Applicable Asset Category", "Subject"]
  let tempDownloadData = structuredClone(rows);
  for(let val of tempDownloadData ){
      let tempDoc = {};
      tempDoc = {...tempDoc, "Category": val.Category, "Applicable Asset Category":val["ApplAssetCateg"].join(","), "Subject":val["Subject"].join(",") }
      finalDownloadData.push(tempDoc)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [rows])

useEffect(()=>{
  setRows(Object.values(complmaster))
},[complmaster])
  
    return (
      <>
        <BackArrowContainer onClick={onClickBackArrow}><ArrowLeftIcon /><span >Back to Complaint Category Table</span></BackArrowContainer>
        <HeadingWrap>
          <Span>Add New Subject</Span>
        </HeadingWrap>

        <form style={{marginBottom:'20px', marginTop:'20px'}}>
          <TextField
            id="outlined-basic"
            size='small'
            label="Complaint Category"
            value={categProp}
            variant="outlined"
            readOnly
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />      
        </form> 
  
        <form onSubmit={onFormSubmit} >
        {[...Array(addSpecIndex)].map((e, i) =>
          <SpecInputContainer key={i}>
            <LabelInputWrapper>
              <TextField
                id="outlined-basic"
                size='small'
                name={`subject${i}`}
                onChange={(event, newValue) => handleAddSubject(event, newValue)}
                label="Subject"
                value={addSubjectData[`subject${i}`]? addSubjectData[`subject${i}`]:""}
                variant="outlined"
                sx={{ backgroundColor:"white", width:"200px" }}
              />      
            </LabelInputWrapper>

                      
              {i === (addSpecIndex -1) &&  <IconWrapper><SubWrapper><AddIcon onClick={onClickaddicon} sx={{ fontSize: 30, marginBottom:"10px" }} />
              <RemoveIcon onClick={onClickremoveicon} sx={{ fontSize: 30, marginBottom:"10px" }} /><SubmitButton type='submit' >Submit</SubmitButton>
              </SubWrapper>
              <Button2Div>
                <ExcelDownload data={downloadData} filename={"Subject-CompCategory"} sheetName={"sheet1"}/>
              </Button2Div> 
              </IconWrapper>}
            </SpecInputContainer>
            )}
        </form>
        <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
              <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"7%"}}} align="center">Sl.No.</TableCell>
              <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Complaint Category</TableCell>
              <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Sub Category</TableCell>           
              <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Delete</TableCell>
           </TableRow>
          </TableHead>
  
          <TableBody>
            {(rowsPerPage > 0
              ? expandedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : expandedRows
            ).map((row,k) => (              
              <TableRow key={k} >
                <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
                  {(page)*(rowsPerPage)+k+1}
                </TableCell>
                <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                  {row.Category}
                </TableCell>
                <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                  {row.Subject}
                </TableCell>         
                <TableCell align="left" sx={{ fontSize: tableFontSize}}>
                  <ButtonWrapper>
                    <SubmitButton type='button' style={{backgroundColor:"#D32F2F", color:"lightgreen", height:"35px", margin:"0px"}}  onClick ={(e)=>handleDeleteClick(e,k,row)}>Delete</SubmitButton>
                  </ButtonWrapper>  
                </TableCell>
            </TableRow>
            ))}
  
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                colSpan={3}
                count={expandedRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>      
      </TableContainer>
      </div>
      </>  
    );
  }
  export default SubjectMaster;